import React from "react";
import { Select } from "antd";

const { Option } = Select;

const TypeSelector = ({ types, value, onChange }) => {
	return (
		<Select value={value} onChange={onChange}>
			{types.map((t) => (
				<Option key={t} value={t}>
					{t}
				</Option>
			))}
		</Select>
	);
};

export default TypeSelector;
